import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Heading, Box, Button, Text } from '@components/common';
import { MobileContainer, DesktopContainer } from '@containers/layout';
import ServiceDateCalendarBoard from './ServiceDateCalendarBoard';
import ScheduleActions, { ScheduleSelectors } from '@redux/ScheduleRedux';
import { BookingSelectors } from '@redux/BookingRedux';
import { AuthSelectors } from '@redux/AuthRedux';
import DefaultLoader from '@components/loading/DefaultLoader';
import API from '@utils/api';
import logger from '@utils/logger';
import { transformAvailableDate } from '@services/transform';

const DesktopWrapper = styled(DesktopContainer)`
  @media screen and (max-width: 767px) {
    flex-direction: column-reverse;
    justify-content: flex-end;
  }
`;

const ContainerView = styled(MobileContainer)`
  align-self: flex-start;
  align-items: stretch;
  z-index: 100;
  @media screen and (max-width: 767px) {
    flex: 0;
  }
  @media screen and (min-width: 1024px) {
    padding-top: 0px;
  }
`;

const MobileOnly = styled(Box)`
  width: 100%;
  @media screen and (min-width: 1024px) {
    display: none;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    display: none;
  }
  @media screen and (max-width: 767px) {
    display: block;
  }
`;

const DesktopOnly = styled(Box)`
  width: 100%;
  @media screen and (max-width: 767px) {
    display: none;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    display: block;
  }
  @media screen and (min-width: 1024px) {
    display: block;
  }
`;

function ServiceDateRecurring(props) {
  const {
    startDate,
    recipient,
    isPMUser,
    confirmDate,
    currentPropertyId
  } = props;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isDisabled = !startDate || isSubmitting;

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      let payload = {
        startFrom: startDate.format('YYYY-MM-DD')
      };

      if (isPMUser) {
        const { propertyID, bedroomsCount } = recipient;
        payload = {
          ...payload,
          propertyID,
          bedroomsCount
        };
      } else {
        payload.propertyID = currentPropertyId;
      }

      const {
        result: { availabilities }
      } = await API.getAvailableDates(payload, isPMUser, 'recurring');

      confirmDate(
        (availabilities || [])
          .map(item => transformAvailableDate(item, true))
          .filter(item => !!item)
      );
    } catch (e) {
      logger.log(e);
    }
    setIsSubmitting(false);
  };

  return (
    <DesktopWrapper>
      <MobileOnly>
        {isSubmitting && (
          <Box
            flex={1}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="Center"
          >
            <DefaultLoader size={64} />
          </Box>
        )}
        <Button
          my={2}
          width={1}
          type="button"
          onClick={handleSubmit}
          disabled={isDisabled}
        >
          Continue
        </Button>
      </MobileOnly>
      <ServiceDateCalendarBoard disabled={isSubmitting} flex={1} />
      <ContainerView>
        <Box position="relative" pt={[4, 0]}>
          <Heading display={['none', 'block']} px={2} mb={4} mt={0}>
            Start Date
          </Heading>
          <Text textAlign={['center', 'left']} px={2} mb={4}>
            What week would you like your service to start?
          </Text>
          <DesktopOnly>
            {isSubmitting && (
              <Box
                flex={1}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="Center"
              >
                <DefaultLoader size={64} />
              </Box>
            )}
            <Button
              my={4}
              width={1}
              type="button"
              onClick={handleSubmit}
              disabled={isDisabled}
            >
              Continue
            </Button>
          </DesktopOnly>
        </Box>
      </ContainerView>
    </DesktopWrapper>
  );
}

ServiceDateRecurring.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  confirmDate: PropTypes.func,
  startDate: PropTypes.object,
  recipient: PropTypes.object,
  isPMUser: PropTypes.bool,
  currentPropertyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

const mapStatesToProps = state => ({
  startDate: ScheduleSelectors.selectStartDate(state),
  isPMUser: AuthSelectors.selectIsPMUser(state),
  recipient: BookingSelectors.selectRecipientInfo(state),
  currentPropertyId: BookingSelectors.selectCurrentPropertyId(state)
});

const mapDispatchToProps = dispatch => ({
  confirmDate: availableDates =>
    dispatch(ScheduleActions.setRecurringConfirmStartDate(availableDates))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(ServiceDateRecurring);
